<template>
  <div id="store-locator">
    <store-locator-form
      :location="location"
    ></store-locator-form>
    <div class="o-wrapper">
      <div class="o-layout">
        <div class="o-layout__item u-push-1/2@lap u-1/2@lap">
          <stores-map
            style="width: 100%; height: 480px"
             v-if="location"
             :location="location"
             :stores="stores"
          ></stores-map>
        </div><!--
        --><div class="o-layout__item u-pull-1/2@lap u-1/2@lap">
          <stores-list
            v-if="stores.length > 0"
            :stores="stores"
          ></stores-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import StoreLocatorForm from './store-locator-form.vue'
  import StoresMap from './stores-map.vue'
  import StoresList from './stores-list.vue'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      'store-locator-form': StoreLocatorForm,
      'stores-map': StoresMap,
      'stores-list': StoresList,
    },
    computed: {
      ...mapGetters([
        'location',
        'stores',
      ])
    }
  }
</script>
